var moduleMap = {
	"./Header": () => {
		return __webpack_require__.e(/* __federation_expose_Header */ 9327).then(() => (() => ((__webpack_require__(74803)))));
	},
	"./Footer": () => {
		return __webpack_require__.e(/* __federation_expose_Footer */ 3913).then(() => (() => ((__webpack_require__(28367)))));
	},
	"./UEHeader": () => {
		return __webpack_require__.e(/* __federation_expose_UEHeader */ 3229).then(() => (() => ((__webpack_require__(42449)))));
	},
	"./UEFooter": () => {
		return __webpack_require__.e(/* __federation_expose_UEFooter */ 5483).then(() => (() => ((__webpack_require__(63507)))));
	},
	"./UESlimHeader": () => {
		return __webpack_require__.e(/* __federation_expose_UESlimHeader */ 9554).then(() => (() => ((__webpack_require__(97427)))));
	},
	"./UESlimFooter": () => {
		return __webpack_require__.e(/* __federation_expose_UESlimFooter */ 2740).then(() => (() => ((__webpack_require__(15254)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope, remoteEntryInitOptions) => {
	return __webpack_require__.federation.bundlerRuntime.initContainerEntry({	webpackRequire: __webpack_require__,
		shareScope: shareScope,
		initScope: initScope,
		remoteEntryInitOptions: remoteEntryInitOptions,
		shareScopeKey: "default"
	})
};


// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});